import { LoadingModal } from "@mixitone/components";
import { ApplicationView } from "@mixitone/mvc";
import Form from "components/Forms/Form";
import FormButtons from "components/Forms/FormButtons";
import { ModalFormFieldset } from "components/Forms/FormRenderers/ModalFormRenderer";
import AppModal from "components/common/AppModal";
import routeService from "services/RouteService";
import { injectModal } from "lib/injectParams";
import { useMemo } from "react";
import { FundingOutreachFormController } from "components/Pages/Funding/FundingOutreachFormController";

const NewApplicationModalContent = ApplicationView(() => {
  const controller = FundingOutreachFormController.use();
  const { saving, loading } = controller.state;
  const fields = useMemo(
    () => Object.values(controller.fields()).filter((f) => f.group === "create"),
    [controller],
  );

  if (loading) return <LoadingModal title="New application" />;

  return (
    <AppModal title="New application">
      <Form name="funding_outreach">
        <fieldset disabled={saving}>
          <ModalFormFieldset fields={fields} />
        </fieldset>
        <FormButtons showDelete={false} saveTitle="Create" />
      </Form>
    </AppModal>
  );
});

const NewApplicationModal = FundingOutreachFormController.scope(NewApplicationModalContent);

export default injectModal((props: { clubId: string }) => (
  <NewApplicationModal
    {...props}
    onSubmit={async () => {
      routeService.closeModal();
    }}
  />
));
